import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ItemService } from '../../services/item.service';
import { IItem } from '../../models/IItem';
import { ActivatedRoute } from '@angular/router';
import { EventService } from '../../services/event.service';

@Component({
    selector: 'item-form',
    templateUrl: './item-form.component.html',
    styleUrls: ['./item-form.component.scss']
})
export class ItemFormComponent implements OnInit {

    form: FormGroup;
    uploaded;
    id;
    collapsed = false;
    detailsVisibility = true;
    weight = 1;
    error;

    constructor(private eventService: EventService, private fb: FormBuilder, public itemService: ItemService, private routes: ActivatedRoute) {
    }

    get detailsV() {
        return this.form.get('detailsVisibility').value;
    }

    ngOnInit(): void {
        const id = this.routes.snapshot.params.id;
        if (id != null) {
            this.id = id;
            this.eventService.getAllOwn().subscribe(res => {
                const array = [];
                res.forEach(ob => {
                    if (ob.items.length > 0) {
                        ob.items.forEach(i => {
                            if (i.id.length < 15) {
                                array.push(i);
                            }
                        });
                    }
                });
                const index = array.findIndex(i => i.id === this.id);
                const own = array[index];
                const item: IItem = {
                  name: own.name,
                  abstract: own.abstract,
                  image: '',
                  type: own.type,
                  description: '',
                  active: true,
                  rating: 0,
                  price: 0,
                  partner: '',
                  reviews: '0',
                  partnerId: '',
                  currency: '€',
                  link: '',
                  weight: this.weight,
                  detailsVisibility: this.detailsVisibility
                };
                this.buildForm(item);
            });
        } else {
            this.uploaded = false;
            this.id = null;
            this.buildForm(null);
        }
    }

    buildForm(item: IItem) {
        this.collapsed = false;
        if (item) {
            this.id = item.id;
        }
        this.form = this.fb.group({
            name: [item ? item.name : '', Validators.required],
            image: [item ? item.image : '', Validators.required],
            type: [item ? item.type : '', Validators.required],
            abstract: [item ? item.abstract : ''],
            description: [item ? item.description : ''],
            active: [item ? item.active : true],
            rating: [item ? item.rating : 0],
            reviews: [item ? item.reviews : '0'],
            price: [item ? item.price : 0],
            partner: [item ? item.partner : ''],
            partnerId: [item ? item.partnerId : ''],
            currency: [item ? item.currency : '€'],
            link: [item ? item.link : ''],
            weight: [item ? item.weight : this.weight, Validators.required],
            detailsVisibility: [item ? item.detailsVisibility : this.detailsVisibility]
        });
    }

    submitForm() {
        this.itemService.set(this.form.getRawValue(), this.id).finally(() => this.ngOnInit());
    }

    toggleItem(id: string, value: boolean) {
        if (this.id) {
            return this.itemService.toggleVisibility(id, value).then(() => this.form.patchValue({ detailsVisibility: !value }));
        } else {
            this.form.patchValue({ detailsVisibility: !value });
        }
    }

    uploadImage(files: FileList) {
        if (!this.uploaded && files.length > 0) {
            if (files[0].type === 'image/jpg' || files[0].type === 'image/png' || files[0].type === 'image/jpeg') {
                this.itemService.uploadImage(files[0]).then(url => {
                    this.form.patchValue({ image: url });
                    this.uploaded = true;
                });
            } else {
                this.error = 'Unsupported image type. Supported only JPG and PNG';
            }
        }
    }

}
